module.exports = __webpack_public_path__ + "img/crossword-small.26675a6e.svg";